// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("/common/jquery-3.6.0.min.js", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("/common/jquery.query.js", import.meta.url);
var ___HTML_LOADER_IMPORT_2___ = new URL("/common/jquery.json.min.js", import.meta.url);
var ___HTML_LOADER_IMPORT_3___ = new URL("/common/default.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_4___ = new URL("/common/timer.js", import.meta.url);
var ___HTML_LOADER_IMPORT_5___ = new URL("/prediction/component-cp/index.js", import.meta.url);
var ___HTML_LOADER_IMPORT_6___ = new URL("/prediction/component-cp/index.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_7___ = new URL("/prediction/component-cp/attention.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_8___ = new URL("/prediction/component-cp/start-button.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_9___ = new URL("/prediction/component-cp/footer-ponta.scss", import.meta.url);
// Module
var code = `<!DOCTYPE html>
<html lang="ja">
  <head
    prefix="og: https://ogp.me/ns# fb: https://ogp.me/ns/ fb# article: https://ogp.me/ns/article#"
  >
    <!-- prettier-ignore -->
    

    <!-- prettier-ignore -->
    <!--デフォルト値の設定-->




<meta charset="UTF-8" />
<meta
  name="viewport"
  content="width=device-width,user-scalable=no,initial-scale=1,maximum-scale=1"
/>
<meta name="format-detection" content="telephone=no" />
<title>テーマ４．外国為替ドル円相場の予想</title>
<meta name="description" content="お金のミカタは、ためる(ポン活)・ふやす(運用)・そなえる(保険)・まなべるサービスを紹介する、“Ponta[ポンタ]“の公式金融総合サイトです" />
<link rel="index" href="index.htm" />
<!-- icon -->
<link
  rel="shortcut icon"
  type="image/vnd.microsoft.icon"
  href="/cmn/img/favicon.ico"
/>
<link rel="icon" type="image/x-icon" href="/cmn/img/favicon.ico" />
<link
  rel="apple-touch-icon"
  sizes="180x180"
  href="/cmn/img/apple-touch-icon.png"
/>
<!-- og -->
<meta property="og:url" content="https://www.finance.ponta.jp/prediction/2-004/" />
<meta property="og:type" content="website" />
<meta property="og:title" content="テーマ４．外国為替ドル円相場の予想" />
<meta property="og:description" content="お金のミカタは、ためる(ポン活)・ふやす(運用)・そなえる(保険)・まなべるサービスを紹介する、“Ponta[ポンタ]“の公式金融総合サイトです" />
<meta property="og:site_name" content="【Ponta】お金のミカタ" />
<meta property="og:image" content="https://www.finance.ponta.jp/cdn/img/ogp.png" />
<!-- Twitter -->
<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:site" content="@Ponta" />

${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_0___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_1___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_2___}">${"<" + "/script"}>

<!-- StyleSheet -->
<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_3___}" />

<!-- noto sans jp の読み込み -->
<link rel="preconnect" href="https://fonts.gstatic.com" />
<link
  rel="preload"
  href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap"
  as="style"
/>
<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap"
  media="print"
  onload="this.media = 'all'"
/>

<!-- corporate-logo の読み込み -->
<link rel="preload" href="/font/corporate-logo.css" as="style" />
<link
  rel="stylesheet"
  href="/font/corporate-logo.css"
  media="print"
  onload="this.media = 'all'"
/>

<!-- Google Tag Manager (loadイベント後に遅延読み込み) -->
<!-- 旧コード: Clarityとアニメーションの競合解消後に戻す
${"<" + "script"}>
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", "GTM-P3QVP6P");
${"<" + "/script"}>
-->
${"<" + "script"}>
  window.dataLayer = window.dataLayer || [];
  window.addEventListener("load", function () {
    dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = document.getElementsByTagName("script")[0],
      j = document.createElement("script");
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=GTM-P3QVP6P";
    f.parentNode.insertBefore(j, f);
  });
${"<" + "/script"}>

<!-- Google広告 -->
${"<" + "script"}
  async
  src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2528660706528280"
  crossorigin="anonymous"
>${"<" + "/script"}>

    <meta name="robots" content="noindex" />
    ${"<" + "script"} src="${___HTML_LOADER_IMPORT_4___}">${"<" + "/script"}>
    ${"<" + "script"} src="${___HTML_LOADER_IMPORT_5___}">${"<" + "/script"}>
    <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_6___}" />
  </head>

  <body>
    <!-- Google Tag Manager (noscript) -->
<noscript
  ><iframe
    src="https://www.googletagmanager.com/ns.html?id=GTM-P3QVP6P"
    height="0"
    width="0"
    style="display: none; visibility: hidden"
  ></iframe
></noscript>
<!-- End Google Tag Manager (noscript) -->

    <div class="body-contents">
      <br />
      <main>
        <div class="bg-white">
          <h2>
            <img
              class="h2_img"
              src="/prediction/img/logo_prediction.svg"
              alt="未来予想でPonta"
              width="300"
              height="72"
            />
          </h2>
          <div class="box-overview">
            <p class="copy">予想を当てて<br class="br_pc" />ポイント山分け</p>
            <p class="explanation">テーマ４．外国為替ドル円相場の予想</p>
            <!--終了メッセージ-->
            <!-- prettier-ignore -->
            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_6___}" />
<p class="event-end timer-target" data-end="2026-06-22T18:00:00+09:00">終了しました</p>

            <table class="overview">
              <tr>
                <th>加算ポイント</th>
                <td>10,000Pontaポイント山分け</td>
              </tr>
              <tr>
                <th>回答期間</th>
                <td>2026年5月25日(月)10:00～<br />2026年6月22日(月)18:00</td>
              </tr>
              <tr>
                <th>加算対象</th>
                <td>予想が当たった人で山分け</td>
              </tr>
              <tr>
                <th>加算時期</th>
                <td>2026年8月末頃予定</td>
              </tr>
            </table>
          </div>
          <p class="notes">
            下記の注意事項をご確認いただきご参加ください。<br />
            回答後に表示されるログインページよりログインいただくことでエントリーが完了します。
          </p>
          <!--attention-->
          <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_7___}" />
<section class="attention">
  <p class="attention-title">注意事項</p>
  <div class="attention-scrollable">
    <div class="attention-text">
      <ul>
        <li>
          予想を途中で変更する場合、改めて予想エントリーをし直すことができます。1テーマで複数回の予想エントリーをした場合、予想エントリーした時間が一番遅いエントリーの予想が最終エントリーになります。
        </li>
        <li>
          各テーマ毎に予想が当たった人で1万ポイントを山分けします。<br />
          　当たった人が1万名を超えた場合、全員に１Pontaポイントを加算いたします。<br />
          　当たった人が1万名に満たない場合、山分けポイントは小数点以下を切り捨てしたポイントを加算いたします。<br />
          　　例：8,000名の場合は１Pontaポイント、4,000名の場合は２Pontaポイント、3,000名の場合は3Pontaポイント
        </li>
        <li>
          ポイント加算は回答期間終了月の翌月末頃を予定しております。<br />
          　※ポイント加算は諸事情により遅れる場合もございます。あらかじめご了承ください。<br />
          　※加算ポイントは<a
            href="https://point.recruit.co.jp/point/pwbBalanceRef/"
            target="_blank"
            rel="noopener noreferrer"
            >PontaWebのポイント通帳</a
          >および、<a
            href="https://www.point-portal.auone.jp/login?targeturl=/point/history&amp;targetquery="
            target="_blank"
            rel="noopener noreferrer"
            >au Ponta ポータルのポイント履歴</a
          >にてご確認いただけます。
        </li>
        <li>
          予想エントリーをするためにはPontaWeb会員登録またはau
          ID連携が必要です。すでにお済みの方は、新たに連携の必要はありません。
        </li>
        <li>
          その他、ポイント加算までに以下の条件に当てはまった場合、ポイント獲得の権利を失います。<br />
          　(1)Pontaを退会された場合<br />
          　(2)Ponta会員IDの登録内容に虚偽・不備がある場合<br />
          　[PontaWebでお預入申し込みをされた場合]<br />
          　(3)リクルートIDを退会された場合<br />
          　(4)PontaWeb会員登録(Ponta会員IDの登録)が行われていない場合<br />
          　[au IDでお預入申し込みをされた場合]<br />
          　(5)au IDの連携を解除された場合<br />
          　(6)au IDの連携が⾏われていない場合<br />
          　その他、(株)ロイヤリティマーケティング、(株)リクルート、KDDI(株)が不正とみなしたPonta会員は、対象外とさせていただく場合があります。
        </li>
        <li>
          以下に該当する行為が確認された場合は、事前の告知なく本サービスの全部または一部を中断・停止または中止する場合があります。<br />
          　(1)不正に取得したＩＤ ・パスワードを使用しアクセスする行為。<br />
          　(2)システムの不具合を故意に悪用する行為 。<br />
          　(3)通信データを改ざんする行為。<br />
          　(4)第三者によるシステムの破壊や妨害行為。(データやソースコードの改ざん・破壊など)<br />
          　(5)他の会員または第三者に不利益を与える行為。<br />
          　(6)当社及び提携会社または第三者に不利益を与える行為。<br />
          　(7)その他、当社が不適当と判断する行為。
        </li>
        <li>
          本サービスの全部または一部が中断・停止または中止となったとしても、これに起因するPonta会員または他の第三者が被ったいかなる不利益、損害について、一切責任を負いかねます。
        </li>
        <li>
          本サービスへのアクセス集中や通信回線の状態による遅延、システムメンテナンスや不具合などにより本サービスへのアクセスができないことにより発生した損害、または起因して発生したすべての事象につきましては、原因の如何によらず一切の責任を負いかねますので、あらかじめご了承ください。
        </li>
        <li>インターネット通信料、接続料はお客様のご負担となります。</li>
        <li>
          ご使用いただいているOSバージョンやブラウザによって、正常に動作しない可能性がありご利用いただけない場合があります。その場合はお手数ですが違うデバイスやブラウザもお試しください。
        </li>
        <li>
          端末のメモリ消費量が多い場合、正常に動画再生、読込が完了しない場合がありますので端末再起動等をお試しください。
        </li>
      </ul>
    </div>
  </div>
</section>

          <!--start-button-->
          <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_8___}" />
<label class="checkbox">
  <input type="checkbox" id="agree" />確認しました
</label>
<br />
<div class="button_container">
  <a
    id="apply"
    data-id="prediction-2-004"
    class="button_entry gray timer-target"
    data-start="2026-05-25T10:00:00+09:00"
    data-end="2026-06-22T18:00:00+09:00"
    href="./main?prv="
  >
    <div class="button_text">アンケートに答えて申し込む</div>
  </a>
  <img
    id="corner-image"
    class="corner-image left-top hidden"
    src="/2-choices/button_shine.svg"
  />
  <img
    id="corner-image"
    class="corner-image right-top hidden"
    src="/2-choices/button_shine.svg"
  />
</div>

          <!-- footer-ponta -->
          <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_9___}" />
<div class="footer-ponta">©Ponta</div>

        </div>
      </main>
    </div>
  </body>
</html>
`;
// Exports
export default code;